/**
 * The one rule inline styles cannot express. Injected at module load, not per component: a
 * `<style>` per field means dozens of copies on a big form, and an effect would flash the label.
 */
export const VISUALLY_HIDDEN_CLASS = 'vt-field-label-hidden'

const CSS =
  `.${VISUALLY_HIDDEN_CLASS}{` +
  'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;' +
  'clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0}'

if (typeof document !== 'undefined' && !document.getElementById(VISUALLY_HIDDEN_CLASS)) {
  const style = document.createElement('style')
  style.id = VISUALLY_HIDDEN_CLASS
  style.textContent = CSS
  document.head.appendChild(style)
}
